import { instructionsExist } from '../../app-integration-instructions/local/paths';

export class Controller {

    /** @ngInject */
    constructor(
        $scope,
        $state,
        AddApplicationModal,
        AddNewApplicationResource,
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
        
    }

    $onInit() {
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.localInstructionsExist = instructionsExist(this.appType);
        if (!this.localInstructionsExist) {
            this.$scope.$on('language-loaded', () => this.loadHelpXml());
            this.loadHelpXml();
        }
        console.log(this.$state.params);
        var isSra=this.appType.slug==='saaspass-secure-remote-access';
        var isAdPasswordManager=this.appType.slug==='ad-password-manager';

        var isSraAllowed=this.appPermissions.sra;
        var isAdPasswordManagerAllowed=this.appPermissions.adPasswordManager;

        this.allowAdd=!((isSra && !isSraAllowed) || (isAdPasswordManager && !isAdPasswordManagerAllowed));
        this.isOidc = this.appType.oidcConfigSupported && this.appType != 'generic-oauth2';
    }

    addNewApplication() {
        if (this.appType.slug === 'office-365') {
            this.AddApplicationModal(this.appType);
            return;
        }
        this.AddNewApplicationResource
            .createSecureApp(this.companyId, this.appType.id)
            .then(app => this.$state.go('company.manage-application', {appId: app.id}))
    }

    loadHelpXml() {
        this.isLoading = true;
        this.AddNewApplicationResource
            .getAllApplicationInfoWithoutParameters(this.companyId, this.appType.id)
            .then(instructions => this.instructions = instructions)
            .finally(() => this.isLoading = false)
    }
    checkIfAdd() {
        var isSra=this.appType.slug==='saaspass-secure-remote-access';
        var isAdPasswordManager=this.appType.slug==='ad-password-manager';

        var isSraAllowed=this.appPermissions.sra;
        var isAdPasswordManagerAllowed=this.appPermissions.adPasswordManager;

        this.allowAdd=!((isSra && !isSraAllowed) || (isAdPasswordManager && !isAdPasswordManagerAllowed));
        return allowAdd;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/application-info/application-info.controller.js